export enum Variant {
    DANGER = 'danger',
    WARNING = 'warning'
}
